import React, { useState } from 'react';
import '../css/CadastrarRepresentanteComercial.css';

import { useNavigate } from 'react-router-dom';

// máscara para telefone
import { aplicarMascaraTelefone } from '../uteis/mascaras/mascaraTelefone';

// api
import { cadastrarRepresentanteComercial } from '../servicos/representanteServico';

function CadastrarRepresentanteComercial() {

  const navigate = useNavigate();

  const [form, setForm] = useState({
    nome: '',
    email: '',
    senha: '',
    confirma_senha: '',
    numero_celular_com_ddd: '',
    st_is_ativo: true,
    data_inicio_vigencia: '',
    data_fim_vigencia: '',
    observacao: '',
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (form.senha !== form.confirma_senha) {
        alert('As senhas não conferem!');
        return;
    }
  
    console.log('Dados do formulário:', form);

    try {
      const resposta = await cadastrarRepresentanteComercial(form);
      alert('Representante cadastrado com sucesso!');
      console.log('Resposta:', resposta);
      navigate('/pagina-adm-tecnico');
    } catch (erro) {
      alert('Erro ao cadastrar representante.');
      console.log('Erro:', erro);
    }
  };
  

  return (
    <div className="card p-4 shadow-sm" style={{ width: '100%', maxWidth: '500px', margin: '2rem auto' }}>
      <div className="card-body">
        <h3 className="text-center mb-4">Cadastrar Representante Comercial</h3>

        <form onSubmit={handleSubmit} autoComplete="off">
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              id="nome"
              name="nome"
              placeholder="Nome completo"
              value={form.nome}
              onChange={handleChange}
              required
            />
            <label htmlFor="nome">Nome completo</label>
          </div>

          <div className="form-floating mb-3">
            <input
              type="email"
              className="form-control"
              id="email"
              name="email"
              placeholder="email@exemplo.com"
              value={form.email}
              onChange={handleChange}
              required
            />
            <label htmlFor="email">E-mail</label>
          </div>

          <div className="form-floating mb-3">
            <input
              type="password"
              autoComplete="new-password"
              className="form-control"
              id="senha"
              name="senha"
              placeholder="Senha"
              value={form.senha}
              onChange={handleChange}
              required
            />
            <label htmlFor="senha">Senha</label>
          </div>

          <div className="form-floating mb-3">
            <input
              type="password"
              autoComplete="new-password"
              className="form-control"
              id="confirmaSenha"
              name="confirma_senha"
              placeholder="Confirme a senha"
              value={form.confirma_senha}
              onChange={handleChange}
              required
            />
            <label htmlFor="confirmaSenha">Confirme a senha</label>
          </div>

          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              id="numeroCelular"
              name="numero_celular_com_ddd"
              placeholder="(83) 91234-5678"
              value={form.numero_celular_com_ddd}
              onChange={(e) => {
                const valorFormatado = aplicarMascaraTelefone(e.target.value);
                setForm((prevForm) => ({
                  ...prevForm,
                  numero_celular_com_ddd: valorFormatado,
                }));
              }}
              maxLength={15}
              required
            />
            <label htmlFor="numeroCelular">Número com DDD</label>
          </div>

          <div className="form-check form-switch mb-3">
            <input
              className="form-check-input"
              type="checkbox"
              id="ativoCheck"
              name="st_is_ativo"
              checked={form.st_is_ativo}
              onChange={handleChange}
            />
            <label className="form-check-label" htmlFor="ativoCheck">
              Ativo
            </label>
          </div>

          <div className="form-floating mb-3">
            <input
              type="date"
              className="form-control"
              id="inicioVigencia"
              name="data_inicio_vigencia"
              value={form.data_inicio_vigencia}
              onChange={handleChange}
              required
            />
            <label htmlFor="inicioVigencia">Início da Vigência</label>
          </div>

          <div className="form-floating mb-3">
            <input
              type="date"
              className="form-control"
              id="fimVigencia"
              name="data_fim_vigencia"
              value={form.data_fim_vigencia}
              onChange={handleChange}
            />
            <label htmlFor="fimVigencia">Fim da Vigência</label>
          </div>

          <div className="form-floating mb-3">
            <textarea
              className="form-control"
              id="observacao"
              name="observacao"
              placeholder="Observações"
              value={form.observacao}
              onChange={handleChange}
              style={{ height: '100px' }}
            />
            <label htmlFor="observacao">Observações</label>
          </div>

          <button type="submit" className="btn btn-primary w-100">Salvar</button>
        </form>
      </div>
    </div>
  );
}

export default CadastrarRepresentanteComercial;
